import {
  Alert, Box, Chip, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ArrowRight } from 'lucide-react';
import { formatPhoneNumber, isPhoneColumnLabel } from '../helpers/phoneDisplay';
import { getColumnDisplayName } from '../helpers/sheetDisplay';

function displayValue(label, value) {
  if (value === null || value === undefined) return 'No registrado';
  if (!String(value).trim()) return 'Sin dato';
  return isPhoneColumnLabel(label) ? formatPhoneNumber(value) : String(value);
}

export default function RequestChangeComparison({ entries = [] }) {
  return (
    <Paper variant="outlined" sx={{ minWidth: 0, overflow: 'hidden', borderColor: 'primary.main' }}>
      <Box sx={{ px: 1.5, py: 1.25, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Cambio solicitado</Typography>
        <Typography variant="caption" sx={{ opacity: 0.9 }}>Revisa los valores actuales y los solicitados.</Typography>
      </Box>
      {entries.length === 0 ? (
        <Alert severity="info" sx={{ m: 1.5 }}>Esta solicitud no contiene cambios de valores.</Alert>
      ) : (
        <TableContainer>
          <Table size="small" aria-label="Comparación del cambio solicitado" sx={{ tableLayout: 'fixed', minWidth: 320,
            '& .MuiTableCell-root': { px: { xs: 0.75, sm: 1.5 }, overflowWrap: 'anywhere', verticalAlign: 'top' } }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, width: '27%' }}>Campo</TableCell>
                <TableCell sx={{ fontWeight: 700, width: '31%' }}>Actual</TableCell>
                <TableCell padding="none" aria-label="Cambia a" sx={{ width: 28 }} />
                <TableCell sx={{ fontWeight: 700 }}>Solicitado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((entry, index) => (
                <TableRow key={`${entry.label}-${index}`} sx={entry.changed
                  ? { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08) } : undefined}>
                  <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
                    {getColumnDisplayName(entry.label, 'Usuarios')}
                  </TableCell>
                  <TableCell sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
                    {displayValue(entry.label, entry.originalValue)}
                  </TableCell>
                  <TableCell padding="none" sx={{ color: entry.changed ? 'primary.main' : 'text.disabled' }}>
                    <ArrowRight size={18} aria-hidden="true" />
                  </TableCell>
                  <TableCell sx={{ fontWeight: entry.changed ? 700 : 400,
                    color: entry.changed ? 'primary.main' : 'text.secondary', whiteSpace: 'pre-line' }}>
                    {displayValue(entry.label, entry.requestedValue)}
                    {entry.changed && <Chip label={entry.originalValue === null ? 'Nuevo' : 'Cambio'}
                      color="primary" size="small" sx={{ ml: 0.75, mt: 0.25 }} />}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}
